<template>
  <div class="lang" @click="changeLanguage">{{ lang }}</div>
</template>

<script>
export default {
  data() {
    return {
      lang: "EN",
    };
  },
  methods: {
    changeLanguage() {
      if (this.$i18n.locale === "zh-CN") {
        this.$i18n.locale = "en-US";
        this.lang = "中";
      } else {
        this.$i18n.locale = "zh-CN";
        this.lang = "EN";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.lang {
  position: fixed;
  top: 15px;
  right: 15px;
  width: 50px;
  height: 50px;
  margin-right: 16px;
  color: #6f6f6f;
  line-height: 50px;
  text-align: center;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  cursor: pointer;
  background-color: white;
}
</style>
